import { apiCall } from "./client";

export function fetchAnnouncement() {
    return apiCall("/api/system/announcement");
}

export function createAnnouncement(payload) {
    return apiCall("/api/system/announcement", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function updateAnnouncement(payload) {
    return apiCall(`/api/system/announcement/${payload.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function deactivateAnnouncement(announcementId) {
    return apiCall(`/api/system/announcement/${announcementId}`, {
        method: "DELETE",
    });
}

export function deleteAnnouncement(announcementId) {
    return apiCall(`/api/system/announcement/${announcementId}/hard-delete`, {
        method: "DELETE",
    });
}

export function moveAnnouncement(announcementId, direction) {
    return apiCall(`/api/system/announcement/${announcementId}/move`, {
        method: "POST",
        body: JSON.stringify({ direction }),
    });
}

export function fetchAppUpdateStatus({ platform, build, version, channel = "production" }) {
    const params = new URLSearchParams({
        platform,
        build: String(build),
        channel,
    });
    if (version) params.set("version", version);
    return apiCall(`/api/system/app-update?${params.toString()}`);
}

export function fetchAppReleaseSettings(platform) {
    return apiCall(`/api/system/admin/app-releases/${platform}`);
}

export function updateAppReleaseSettings(platform, payload) {
    return apiCall(`/api/system/admin/app-releases/${platform}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}
